import { LinkProps } from '@gazin/ecommerce-ui'

type GetStylesType = {
  shareOptions: LinkProps
}

export const getStyles = (): GetStylesType => ({
  shareOptions: {
    flexGrow: 1,
    margin: '0.4375rem',
    textAlign: 'center',
    width: '33%',
  },
})
